import { render } from "./abandon_form.vue?vue&type=template&id=580ae4d9&scoped=true"
import script from "./abandon_form.vue?vue&type=script&lang=js"
export * from "./abandon_form.vue?vue&type=script&lang=js"

import "../../../assets/css/modal.css?vue&type=style&index=0&id=580ae4d9&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580ae4d9"]])

export default __exports__